import script from "./items.vue?vue&type=script&setup=true&lang=js"
export * from "./items.vue?vue&type=script&setup=true&lang=js"

import "./items.vue?vue&type=style&index=0&id=375cbb16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375cbb16"]])

export default __exports__